type ShiftType = 'days_only' | 'nights_only' | 'both';

interface ShiftTypeSelectorProps {
  value: ShiftType;
  onChange: (value: ShiftType) => void;
  disabled?: boolean;
}

export const ShiftTypeSelector = ({ 
  value, 
  onChange, 
  disabled = false 
}: ShiftTypeSelectorProps) => {
  const options: { value: ShiftType; label: string; description: string }[] = [
    { 
      value: 'days_only', 
      label: 'Days Only', 
      description: 'Provider will only be scheduled for day shifts'
    },
    { 
      value: 'nights_only', 
      label: 'Nights Only', 
      description: 'Provider will only be scheduled for night shifts'
    },
    { 
      value: 'both', 
      label: 'Both', 
      description: 'Provider can be scheduled for both day and night shifts'
    }
  ];

  return (
    <div className="space-y-4">
      {options.map((option) => (
        <div
          key={option.value}
          className={`
            relative flex items-start p-4 border rounded-lg cursor-pointer
            ${value === option.value ? 'border-primary-500 bg-primary-50' : 'border-gray-200'}
            ${disabled ? 'opacity-60 cursor-not-allowed' : 'hover:bg-gray-50'}
          `}
          onClick={() => {
            if (!disabled) {
              onChange(option.value);
            }
          }}
        >
          <div className="min-w-0 flex-1 text-sm">
            <div className="font-medium text-gray-900">{option.label}</div>
            <p className="text-gray-500">{option.description}</p>
          </div>
          <div className="ml-3 flex h-5 items-center">
            <input
              type="radio"
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              disabled={disabled}
              className="h-4 w-4 text-primary-600 border-gray-300 focus:ring-primary-500"
            />
          </div>
        </div>
      ))}
    </div>
  );
}; 